import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetMaterialsPanelComponent } from './get-materials-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    GetMaterialsPanelComponent],
  exports: [
    GetMaterialsPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule
  ],
})
export class GetMaterialsPanelModule { }